import { useState } from 'react'
import { fetcher, AdminPurchaseRewardPromotionsEndpoints, IUsePurchaseRewardPromotions } from '@olagg/api-hooks'
import { PurchaseRewardPromotion } from '@olagg/db-types'

interface PurchaseRewardPromotionsResponse {
  purchaseRewardPromotions: PurchaseRewardPromotion[]
  meta: {
    count: number
  }
}

const usePurchaseRewardPromotions = () => {
  const [loading, setLoading] = useState(false)

  const getPromotions = async (filter: IUsePurchaseRewardPromotions): Promise<PurchaseRewardPromotionsResponse> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardPromotionsEndpoints.all(filter)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching purchase reward promotions:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getPromotion = async (id: string): Promise<PurchaseRewardPromotion> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardPromotionsEndpoints.find(id)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error fetching purchase reward promotion:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createPromotion = async (data: Partial<PurchaseRewardPromotion>): Promise<PurchaseRewardPromotion> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardPromotionsEndpoints.create(data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error creating purchase reward promotion:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updatePromotion = async (id: string, data: Partial<PurchaseRewardPromotion>): Promise<PurchaseRewardPromotion> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardPromotionsEndpoints.update(id, data)
      const response = await fetcher(endpoint)
      return response
    } catch (error) {
      console.error('Error updating purchase reward promotion:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deletePromotion = async (id: string): Promise<void> => {
    try {
      setLoading(true)
      const endpoint = AdminPurchaseRewardPromotionsEndpoints.delete(id)
      await fetcher(endpoint)
    } catch (error) {
      console.error('Error deleting purchase reward promotion:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getPromotions,
    getPromotion,
    createPromotion,
    updatePromotion,
    deletePromotion
  }
}

export default usePurchaseRewardPromotions
